/**
 * Gözlem formu — veli ekranı.
 *
 * Maddeler bizim yazdığımız maddeler; telifli bir ölçeğin maddeleri
 * kullanılmıyor. Ekranda puan GÖSTERİLMİYOR ve gösterilmeyecek:
 * doldurana "şu kadar puan aldınız" demek, formu bir test gibi
 * algılatır ve sonraki doldurmaları çarpıtır.
 */

import { useState } from 'react'
import type { FormTanimi } from '../api'

export function GozlemFormu({
  tanim,
  not,
  onGonder,
  onIptal,
}: {
  tanim: FormTanimi
  /** Uygulayıcının form isteğine eklediği not */
  not?: string | null
  onGonder: (cevaplar: Record<string, number>) => Promise<void>
  onIptal?: () => void
}) {
  const [cevaplar, setCevaplar] = useState<Record<string, number>>({})
  const [hata, setHata] = useState<string | null>(null)
  const [bekliyor, setBekliyor] = useState(false)

  const eksik = tanim.maddeler.filter((m) => cevaplar[m.anahtar] === undefined)

  const gonder = async (e: React.FormEvent) => {
    e.preventDefault()
    setHata(null)
    setBekliyor(true)
    try {
      await onGonder(cevaplar)
    } catch {
      setHata('Gönderilemedi. Bağlantınızı kontrol edip tekrar deneyin.')
    } finally {
      setBekliyor(false)
    }
  }

  return (
    <form onSubmit={gonder}>
      <h1>{tanim.ad}</h1>
      <p className="alt">{tanim.aciklama}</p>

      {hata && <div className="uyari">{hata}</div>}

      {not && (
        <div className="bilgi">
          <strong>Uygulayıcının notu:</strong> {not}
        </div>
      )}

      {tanim.maddeler.map((m, i) => (
        <div className="kart" key={m.anahtar} style={{ marginBottom: 10 }}>
          <div style={{ marginBottom: 8 }}>
            <span className="alt" style={{ margin: 0, marginRight: 6 }}>
              {i + 1}.
            </span>
            {m.metin}
          </div>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {tanim.secenekler.map((s, puan) => (
              <button
                key={s}
                type="button"
                className={cevaplar[m.anahtar] === puan ? 'birincil' : ''}
                onClick={() => setCevaplar({ ...cevaplar, [m.anahtar]: puan })}
              >
                {s}
              </button>
            ))}
          </div>
        </div>
      ))}

      <div className="kart">
        {eksik.length > 0 ? (
          <p style={{ margin: '0 0 10px' }}>
            {eksik.length} madde boş. Boş bırakabilirsiniz ama her madde daha doğru bir resim
            veriyor.
          </p>
        ) : (
          <p style={{ margin: '0 0 10px' }}>Bütün maddeler işaretlendi.</p>
        )}
        <div className="dugmeler">
          <button
            className="birincil"
            type="submit"
            disabled={bekliyor}
          >
            {bekliyor ? 'Gönderiliyor…' : 'Gönder'}
          </button>
          {onIptal && (
            <button type="button" onClick={onIptal} disabled={bekliyor}>
              Vazgeç
            </button>
          )}
        </div>
      </div>
    </form>
  )
}
